import type { ReactNode } from 'react'
import { cx } from '@/app/lib/utils'
import styles from './Tag.module.scss'
import type { TagProps } from './types'

/**
 * Tag — etiqueta transversal del DS Entradas.
 * Esquinas rectas (`--border-radius-base` = 0) y tipografía Label/S.
 * Siempre hug (fit-content), nunca fill.
 */
export function Tag({ children, variant = 'default', className }: TagProps): ReactNode {
  return (
    <span className={cx(styles.tag, styles[variant], className)}>
      {children}
    </span>
  )
}
